import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PublicLayout } from "../../components/PublicLayout";
import { ProductCard } from "../../components/ProductCard";
import { api } from "../../lib/apiClient";
import { useFavorites } from "../../hooks/useFavorites";
import { Heart } from "lucide-react";

export default function Favoritos() {
  const { favs } = useFavorites();
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => { api.get("/products").then((r) => setProducts(r.data)).catch(() => {}); }, []);
  const list = products.filter((p) => favs.includes(p.id));

  return (
    <PublicLayout>
      <div className="max-w-6xl mx-auto px-5 sm:px-6 pt-8">
        <p className="font-serif italic text-vino/60 text-lg">tus antojitos guardados</p>
        <h1 className="font-serif text-4xl sm:text-5xl text-vino tracking-tight leading-none mb-6">Tus favoritos</h1>
        {list.length === 0 ? (
          <div className="text-center py-16">
            <div className="w-20 h-20 mx-auto rounded-full bg-rosa/20 flex items-center justify-center mb-4"><Heart className="w-10 h-10 text-vino/50" /></div>
            <p className="text-cafe/60">Aún no tienes favoritos. Toca el corazón en tus dulces preferidos 💕</p>
            <button onClick={() => navigate("/catalogo")} data-testid="favs-explore" className="mt-5 bg-vino text-crema rounded-full px-8 py-3.5 font-medium">Explorar catálogo</button>
          </div>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 pb-8">
            {list.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
          </div>
        )}
      </div>
    </PublicLayout>
  );
}
